query GetMerchants($company_id: ID!) {
  merchants(company_id: $company_id) {
    companyId
    id
    name
    type
  }
}
